import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import ChatPanel from "@/components/ChatPanel";
import VoicePanel from "@/components/VoicePanel";
import { CircleNotch, WarningCircle, Waveform } from "@phosphor-icons/react";

export default function Widget() {
  const { agentId } = useParams();
  const [agent, setAgent] = useState(null);
  const [error, setError] = useState(false);
  const preview = new URLSearchParams(window.location.search).get("preview") === "1";
  const previewQ = preview ? "?preview=1" : "";

  useEffect(() => {
    api.get(`/public/agents/${agentId}${previewQ}`)
      .then((r) => setAgent(r.data))
      .catch(() => setError(true));
  }, [agentId]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#FAFAFA] p-6 text-center">
        <WarningCircle size={40} className="text-zinc-400 mb-3" />
        <h1 className="font-display font-bold text-xl">Agenten är inte tillgänglig</h1>
        <p className="text-zinc-500 mt-1">Den här agenten är inte live eller finns inte.</p>
      </div>
    );
  }

  if (!agent) {
    return <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]"><CircleNotch size={28} className="animate-spin text-[#0033FF]" /></div>;
  }

  const chatPath = `/public/agents/${agentId}/chat${previewQ}`;
  const isVoice = agent.type === "voice";
  const proactiveRef = new URLSearchParams(window.location.search).get("ref") || undefined;

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col items-center justify-center p-4 sm:p-6">
      <div className="w-full max-w-3xl">
        <div className="flex items-center justify-center gap-2 mb-4 text-zinc-400 text-sm">
          <Waveform size={16} weight="bold" /> Drivs av <span className="font-semibold text-zinc-600">Senzum AI</span>
        </div>
        <div className="h-[88vh] max-h-[1000px] rounded-2xl border border-zinc-200 overflow-hidden shadow-xl bg-white">
          {isVoice
            ? <VoicePanel chatPath={chatPath} ttsPath={`/public/agents/${agentId}/tts`} agent={agent} />
            : <ChatPanel chatPath={chatPath} agent={agent} proactiveRef={proactiveRef} />}
        </div>
      </div>
    </div>
  );
}
